// *******************************************************************************
// 1.0 - Secondary Nav
// *******************************************************************************

// Toggle Secondary Nav Class

const toggleSecondaryNav = (toggle) => {
  document.body.classList.toggle('is-open-secondary-nav', toggle);
};

// Height Calculation
const secondaryNavHeight = () => {
  const secondaryNav = document.querySelector('.secondary-nav');

  if (secondaryNav) {
    setTimeout(() => {
      const secondaryNavHeight = `${secondaryNav.offsetHeight}px`;
      document.documentElement.style.setProperty('--secondary-nav-height', secondaryNavHeight);
    }, 300);

    const secondaryNavMenu = secondaryNav.querySelector('.secondary-nav__nav');

    const hasManyItems = secondaryNav.classList.contains('has-many-items');
    const windowWidthLimit = hasManyItems ? 1600 : 1440;

    if (windowWidth() < windowWidthLimit) {
      secondaryNavMenu?.classList.add('hide');
      toggleSecondaryNav(false);
      setTimeout(() => {
        secondaryNavMenu?.classList.remove('hide');
        secondaryNav?.classList.add('has-more-items');
      }, 300);
    } else {
      secondaryNav?.classList.remove('has-more-items');
    }
  }
};

secondaryNavHeight();

window.addEventListener('resize', () => {
  secondaryNavHeight();
});

// Toggle active class on scroll
const navLinks = document.querySelectorAll('.secondary-nav__nav-link');
navLinks.forEach((link) => {
  const parentElem = link.closest('.secondary-nav__nav-item');
  const linkId = link.getAttribute('href');

  if (linkId && linkId !== '#') {
    const sectionElem = document.querySelector(
      linkId.startsWith('http://') || linkId.startsWith('https://') ? `[href="${linkId}"]` : linkId,
    );

    if (sectionElem) {
      gsap.timeline({
        scrollTrigger: {
          trigger: sectionElem,
          start: 'top center',
          end: 'bottom center',
          scrub: true,
          toggleClass: { targets: parentElem, className: 'is-active' },
        },
      });
    }
  }
});

// Toggle Secondary Nav
attachEvent('.secondary-nav__trigger', 'click', () => {
  const isOpen = document.body.classList.contains('is-open-secondary-nav');
  toggleSecondaryNav(!isOpen);
});

// Close Secondary Nav on ESC key press
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    toggleSecondaryNav(false);
  }
});

// Close Secondary Nav on Outside Click
document.addEventListener('click', (evt) => {
  const secondaryNavContainer = document.querySelector('.secondary-nav');
  let targetElement = evt.target; // clicked element

  do {
    if (targetElement === secondaryNavContainer) {
      return;
    }
    targetElement = targetElement.parentNode;
  } while (targetElement);

  toggleSecondaryNav(false);
});
